var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNotIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.834,
    height: 22.85,
    viewBox: "0 0 20.834 22.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-at-May-06-18-34-25",
    transform: "translate(-30.044 550.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M-419.145-1041.114h-.545a2.341,2.341,0,0,1-2.245-2.147c0-.3,0-.666-.006-1.129,0-.849,0-1.975,0-3.4v-.3l0-1.693.012-7.883.089-.31a5.588,5.588,0,0,1,.3-.735,3.937,3.937,0,0,1,2.875-2.165,23.058,23.058,0,0,1,2.56-.058h1.015c.73,0,1.231,0,1.24,0s-.041.132-.085.264a3.32,3.32,0,0,0-.1.976l-.015.728h-2.041a18.575,18.575,0,0,0-2.29.054,2.014,2.014,0,0,0-1.515,1.41c-.07.245-.074.545-.074,5.342v5.086h9.917v-4.164l.879-.879c.718-.718.9-.883.988-.883h.108v4.121c0,3.549-.008,4.174-.058,4.459a3.9,3.9,0,0,1-1.24,2.255,3.981,3.981,0,0,1-1.742.952c-.31.082-.31.082-5.139.094h-.01l-.907,0h-.126C-418.039-1041.116-418.646-1041.114-419.145-1041.114Zm4.067-3.947a.91.91,0,0,0-.853.575.986.986,0,0,0,.226,1.091.944.944,0,0,0,.677.3,1.006,1.006,0,0,0,.489-.134.992.992,0,0,0,.453-1.189,1.158,1.158,0,0,0-.6-.6A1.655,1.655,0,0,0-415.078-1045.061Z",
    transform: "translate(451.985 513)",
    fill: "#939a9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M286.865-547.854a1.157,1.157,0,0,0-.728.626l-.139.278v3.094c0,3.447-.016,3.276.375,3.7a1.408,1.408,0,0,0,.819.428l.145.032v2.7l1.354-1.349,1.349-1.349,2.89-.016c3.3-.016,3.152,0,3.6-.492.4-.439.385-.262.385-3.661v-3.04l-.139-.278a1.578,1.578,0,0,0-.332-.439c-.4-.332-.246-.321-5.01-.316A43.985,43.985,0,0,0,286.865-547.854Z",
    transform: "translate(-246.039 -3.033)",
    fill: "#939a9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNotIcon);
export default __webpack_public_path__ + "static/media/phone__not__icon.2ff3f2deab22754f843f9c35ece71e37.svg";
export { ForwardRef as ReactComponent };